import { useSearchParams } from "react-router-dom"
import styled from "styled-components"
import { colors } from "../../Utils/color"
import { useEffect, useState } from "react"
import MovieDetails from "../../Components/MovieDetails"
import {
    PlayMovieDiv,
    StyledIFrame,
    SynopsisDiv,
    WatchMovieDiv,
} from "../../Utils/style"
import { AddBannerDiv } from "../Home"
import AdsterraBanner from "../../Components/AdsterraBanner"

const HostDiv = styled.div`
    width: 100%;
    background-color: ${colors.backgrond};
    display: flex;
    justify-content: center;
    gap: 15px;
    overflow-x: auto;
    scrollbar-width: none;
    padding: 10px 0;
    border-radius: 10px;
    margin-bottom: 10px;
    @media screen and (max-width: 744px) {
        //justify-content: flex-start;
        flex-wrap: wrap;
        border-radius: 0;
        //padding: 10;
    }
    @media screen and (min-width: 744px) and (max-width: 1024px) {
    }

    > button {
        color: ${colors.textColor};
        font-size: 0.9em;
        font-weight: 600;
        padding: 10px 25px;
        border-radius: 30px;
        border: none;
        background: ${colors.secondary};
        box-shadow: 2px 2px 6px 2px rgba(250, 250, 250, 0.1);
        cursor: pointer;

        &:hover {
            background-color: ${colors.primary};
        }
    }
`
const MissingLinksDiv = styled.div`
    position: relative;
    width: 100%;
    height: 400px;
    background-color: ${colors.backgrond};
    color: rgba(255, 255, 255, 0.6);
    font-size: 1.2em;
    font-weight: 500;
    text-align: center;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
`

function WatchMovie() {
    const [searchParams] = useSearchParams()

    const movieID = searchParams.get("film_id")

    const [movieInfos, setMovieInfos] = useState([])
    const [date, setDate] = useState()
    const [acteurs, setActeurs] = useState([])
    const [real, setReal] = useState([])
    const [genres, setGenres] = useState([])
    const [pays, setPays] = useState([])
    const [setError] = useState(null)

    const fetchMovie = async (id) => {
        console.log(id)
        try {
            const API_BASE =
                process.env.NODE_ENV === "development"
                    ? "http://127.0.0.1:8787"
                    : window.location.origin

            const response = await fetch(`${API_BASE}/api/film/${id}`)
            if (!response.ok) throw new Error(`HTTP ${response.status}`)
            const json = await response.json()

            setMovieInfos(json.film)
            setActeurs(json.film.acteurs.split(","))
            setReal(json.film.realisateurs.split(","))
            setPays(json.pays)
            setGenres(json.genres)

            const date_sortie = new Date(json.film.date_sortie)

            setDate(
                date_sortie.toLocaleDateString("fr-FR", {
                    day: "numeric",
                    month: "long",
                    year: "numeric",
                }),
            )

            document.title = `Film ${json.film.titre ?? "film"} (${
                json.film.date_sortie.slice(0, 4) ?? "annee"
            }) | en streaming complet`
        } catch (error) {
            console.error("Erreur API:", error)
            setError("Impossible de charger le film. Réessayez plus tard.")
            console.log("Impossible de charger le film. Réessayez plus tard.")
        }
    }

    useEffect(() => {
        fetchMovie(movieID)
    }, [movieID])

    const [play, setPlay] = useState(false)
    const [frame, setFrame] = useState(false)
    const [uqload, setUqload] = useState(false)
    const [dood, setDood] = useState(false)
    const [voe, setVoe] = useState(false)
    const [filemoon, setFilemoon] = useState(false)

    const [missingLink, setMissingLink] = useState(false)

    const watchMovieHandleClick = async (event) => {
        event.preventDefault()

        setPlay(true)

        //const watchFrame = document.getElementById("watchFrame")

        if (event.target.id === "uqloadBTN" || event.target.id === "playBTN") {
            setUqload(true)
            setDood(false)
            setVoe(false)
            setFilemoon(false)

            const uLink = movieInfos.uqload_link

            if (uLink === "" || uLink === null) {
                setHostUrl("")
                setMissingLink(true)
                setFrame(false)
            } else {
                setFrame(true)
                setHostUrl(uLink)
                setMissingLink(false)
            }
        } else if (event.target.id === "doodBTN") {
            setDood(true)
            setUqload(false)
            setVoe(false)
            setFilemoon(false)

            const dLink = movieInfos.dood_link

            if (dLink === "" || dLink === null) {
                setHostUrl("")
                setMissingLink(true)
                setFrame(false)
            } else {
                setFrame(true)
                setHostUrl(dLink)
                setMissingLink(false)
            }
        } else if (event.target.id === "voeBTN") {
            setVoe(true)
            setDood(false)
            setUqload(false)
            setFilemoon(false)

            const vLink = movieInfos.voe_link

            if (vLink === "" || vLink === null) {
                setHostUrl("")
                setMissingLink(true)
                setFrame(false)
            } else {
                setFrame(true)
                setHostUrl(vLink)
                setMissingLink(false)
            }
        } else if (event.target.id === "filemoonBTN") {
            setFilemoon(true)
            setVoe(false)
            setDood(false)
            setUqload(false)

            const fLink = movieInfos.filemoon_link

            if (fLink === "" || fLink === null) {
                setHostUrl("")
                setMissingLink(true)
                setFrame(false)
            } else {
                setFrame(true)
                setHostUrl(fLink)
                setMissingLink(false)
            }
        }
    }

    const [hostUrl, setHostUrl] = useState(null)

    const isMobile = window.innerWidth < 768

    return (
        <WatchMovieDiv>
            <h1>
                <span></span>
                {movieInfos.titre}
            </h1>

            <HostDiv>
                <button
                    id="uqloadBTN"
                    uqload={uqload}
                    onClick={watchMovieHandleClick}
                    style={{
                        backgroundColor: uqload
                            ? colors.primary
                            : colors.secondary,
                    }}
                >
                    UQLOAD
                </button>
                <button
                    id="doodBTN"
                    dood={dood}
                    onClick={watchMovieHandleClick}
                    style={{
                        backgroundColor: dood
                            ? colors.primary
                            : colors.secondary,
                    }}
                >
                    DOOD
                </button>
                <button
                    id="voeBTN"
                    voe={voe}
                    onClick={watchMovieHandleClick}
                    style={{
                        backgroundColor: voe
                            ? colors.primary
                            : colors.secondary,
                    }}
                >
                    VOE
                </button>
                <button
                    id="filemoonBTN"
                    filemoon={filemoon}
                    onClick={watchMovieHandleClick}
                    style={{
                        backgroundColor: filemoon
                            ? colors.primary
                            : colors.secondary,
                    }}
                >
                    FILEMOON
                </button>
            </HostDiv>
            <PlayMovieDiv
                play={play}
                style={{ display: play ? "none" : "block" }}
            >
                <img src={movieInfos.cover} alt="Movie cover" />
                <button id="playBTN" onClick={watchMovieHandleClick}>
                    <i class="fa-solid fa-play"></i>
                    Regarder
                </button>
            </PlayMovieDiv>

            <MissingLinksDiv
                missingLink={missingLink}
                style={{ display: missingLink ? "flex" : "none" }}
            >
                Fichier Introuvable
            </MissingLinksDiv>

            {/*<StyledIFrame
                id="watchFrame"
                style={{ display: frame ? "block" : "none" }}
                title="MoviesLink"
                hostUrl={hostUrl}
                setHostUrl={setHostUrl}
                src={hostUrl}
                allow="fullscreen; autoplay; encrypted-media; picture-in-picture;"
                sandbox="allow-same-origin allow-scripts"
                webkitAllowFullScreen
                mozallowfullscreen
                allowfullscreen
                frameborder="0"
            ></StyledIFrame>*/}

            <StyledIFrame
                id="watchFrame"
                style={{ display: frame ? "block" : "none" }}
                title="MoviesLink"
                hostUrl={hostUrl}
                setHostUrl={setHostUrl}
                src={hostUrl}
                frameborder="0"
                allow="fullscreen; autoplay; encrypted-media; picture-in-picture"
                allowfullscreen
                webkitallowfullscreen
                mozallowfullscreen
            ></StyledIFrame>

            <AddBannerDiv style={{ marginTop: "5px" }}>
                <p>
                    Cliquer sur les pub est le meilleur moyen de nous soutenir
                </p>
                {isMobile ? (
                    <AdsterraBanner
                        keyId="36095d1eafe994c25e794db19ac32ddd"
                        width={320}
                        height={50}
                    />
                ) : (
                    <AdsterraBanner
                        keyId="dcfa5d9b41f84b62a0d227806e4b1618"
                        width={728}
                        height={90}
                    />
                )}
            </AddBannerDiv>

            <MovieDetails
                movieInfos={movieInfos}
                date={date}
                genres={genres}
                real={real}
                acteurs={acteurs}
                pays={pays}
            />

            <SynopsisDiv>
                <h2>
                    <span></span>Synopsis
                </h2>
                <p>{movieInfos.synopsis}</p>
            </SynopsisDiv>
        </WatchMovieDiv>
    )
}

export default WatchMovie
